import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon, MailIcon, MapPinIcon, FacebookIcon, InstagramIcon, TwitterIcon, YoutubeIcon, ArrowUpIcon } from 'lucide-react';
const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <footer className="bg-blue-950 text-white" data-id="element-363">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-12" data-id="element-364">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-365">
          {/* School Info */}
          <div data-id="element-366">
            <div className="flex items-center space-x-3 mb-6" data-id="element-367">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sVQyanUwhMphyB8je7Yk6r/4.png" alt="Isonyin Grammar School Logo" className="h-16 w-16 object-contain" data-id="element-368" />
              <div data-id="element-369">
                <h3 className="text-lg font-bold leading-tight" data-id="element-370">
                  Isonyin Grammar School
                </h3>
                <p className="text-xs text-yellow-300" data-id="element-371">God is our Foundation</p>
              </div>
            </div>
            <p className="text-gray-300 mb-6" data-id="element-372">
              Providing quality education since March 23, 1956. We are committed
              to developing well-rounded individuals who excel academically and
              contribute positively to society.
            </p>
            <div className="flex space-x-4" data-id="element-373">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="bg-blue-900 hover:bg-blue-800 p-2 rounded-full transition-colors" data-id="element-374">
                <FacebookIcon className="h-5 w-5" data-id="element-375" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="bg-blue-900 hover:bg-blue-800 p-2 rounded-full transition-colors" data-id="element-376">
                <TwitterIcon className="h-5 w-5" data-id="element-377" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="bg-blue-900 hover:bg-blue-800 p-2 rounded-full transition-colors" data-id="element-378">
                <InstagramIcon className="h-5 w-5" data-id="element-379" />
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="bg-blue-900 hover:bg-blue-800 p-2 rounded-full transition-colors" data-id="element-380">
                <YoutubeIcon className="h-5 w-5" data-id="element-381" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-382">
            <h3 className="text-lg font-bold mb-6 border-b border-blue-800 pb-2" data-id="element-383">
              Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-384">
              <li data-id="element-385">
                <Link to="/about" className="text-gray-300 hover:text-yellow-300 transition-colors flex items-center" data-id="element-386">
                  <span className="mr-2" data-id="element-387">›</span> About
                </Link>
              </li>
              <li data-id="element-388">
                <Link to="/admissions" className="text-gray-300 hover:text-yellow-300 transition-colors flex items-center" data-id="element-389">
                  <span className="mr-2" data-id="element-390">›</span> Admissions
                </Link>
              </li>
              <li data-id="element-391">
                <Link to="/academics" className="text-gray-300 hover:text-yellow-300 transition-colors flex items-center" data-id="element-392">
                  <span className="mr-2" data-id="element-393">›</span> Academics
                </Link>
              </li>
              <li data-id="element-394">
                <Link to="/student-life" className="text-gray-300 hover:text-yellow-300 transition-colors flex items-center" data-id="element-395">
                  <span className="mr-2" data-id="element-396">›</span> Student Life
                </Link>
              </li>
              <li data-id="element-397">
                <Link to="/news" className="text-gray-300 hover:text-yellow-300 transition-colors flex items-center" data-id="element-398">
                  <span className="mr-2" data-id="element-399">›</span> News & Events
                </Link>
              </li>
              <li data-id="element-400">
                <Link to="/alumni" className="text-gray-300 hover:text-yellow-300 transition-colors flex items-center" data-id="element-401">
                  <span className="mr-2" data-id="element-402">›</span> Alumni
                </Link>
              </li>
              <li data-id="element-403">
                <Link to="/contact" className="text-gray-300 hover:text-yellow-300 transition-colors flex items-center" data-id="element-404">
                  <span className="mr-2" data-id="element-405">›</span> Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-406">
            <h3 className="text-lg font-bold mb-6 border-b border-blue-800 pb-2" data-id="element-407">
              Contact Information
            </h3>
            <ul className="space-y-4" data-id="element-408">
              <li className="flex items-start" data-id="element-409">
                <MapPinIcon className="h-5 w-5 mr-3 text-yellow-400 flex-shrink-0 mt-1" data-id="element-410" />
                <span className="text-gray-300" data-id="element-411">
                  Isonyin Grammar School, Isonyin Road, Ijebu-Ode, Ogun State,
                  Nigeria
                </span>
              </li>
              <li className="flex items-center" data-id="element-412">
                <PhoneIcon className="h-5 w-5 mr-3 text-yellow-400 flex-shrink-0" data-id="element-413" />
                <a href="tel:+2349055172703" className="text-gray-300 hover:text-yellow-300 transition-colors" data-id="element-414">
                  +234 905 517 2703
                </a>
              </li>
              <li className="flex items-center" data-id="element-415">
                <MailIcon className="h-5 w-5 mr-3 text-yellow-400 flex-shrink-0" data-id="element-416" />
                <a href="mailto:info@isonyingrammarschool.ng" className="text-gray-300 hover:text-yellow-300 transition-colors" data-id="element-417">
                  info@isonyingrammarschool.ng
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div data-id="element-418">
            <h3 className="text-lg font-bold mb-6 border-b border-blue-800 pb-2" data-id="element-419">
              Stay Updated
            </h3>
            <p className="text-gray-300 mb-4" data-id="element-420">
              Subscribe to our newsletter to receive updates on school
              activities, events, and news.
            </p>
            <form className="space-y-3" data-id="element-421">
              <div data-id="element-422">
                <input type="email" placeholder="Your Email Address" className="w-full px-4 py-2 rounded-md bg-blue-900 border border-blue-800 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-transparent" data-id="element-423" />
              </div>
              <button type="submit" className="bg-yellow-500 text-blue-900 font-bold px-4 py-2 rounded-md hover:bg-yellow-400 transition-colors shadow-md hover:shadow-lg transform hover:-translate-y-0.5" data-id="element-424">
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Powered By Section */}
      <div className="bg-blue-900 py-3 border-t border-blue-800 border-b border-blue-800" data-id="element-425">
        <div className="container mx-auto px-4" data-id="element-426">
          <div className="flex justify-center items-center" data-id="element-427">
            <div className="flex items-center" data-id="element-428">
              <div className="w-10 h-10 bg-yellow-500 rounded-full flex items-center justify-center mr-3" data-id="element-429">
                <span className="font-bold text-blue-900 text-xs" data-id="element-430">1973/77</span>
              </div>
              <p className="text-white font-medium" data-id="element-431">
                Powered by{' '}
                <span className="text-yellow-400 font-bold" data-id="element-432">1973/77 Set</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="bg-blue-900 py-4" data-id="element-433">
        <div className="container mx-auto px-4" data-id="element-434">
          <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-435">
            <div className="text-center md:text-left mb-4 md:mb-0" data-id="element-436">
              <p className="text-gray-300 text-sm" data-id="element-437">
                © {new Date().getFullYear()} Isonyin Grammar School. All rights
                reserved.
              </p>
            </div>
            <div className="flex space-x-4 text-sm" data-id="element-438">
              <Link to="/privacy-policy" className="text-gray-300 hover:text-yellow-300 transition-colors" data-id="element-439">
                Privacy Policy
              </Link>
              <Link to="/terms-of-use" className="text-gray-300 hover:text-yellow-300 transition-colors" data-id="element-440">
                Terms of Use
              </Link>
              <Link to="/sitemap" className="text-gray-300 hover:text-yellow-300 transition-colors" data-id="element-441">
                Sitemap
              </Link>
              <button onClick={scrollToTop} className="text-gray-300 hover:text-yellow-300 transition-colors flex items-center" aria-label="Scroll to top" data-id="element-442">
                <ArrowUpIcon className="h-4 w-4 mr-1" data-id="element-443" />
                <span data-id="element-444">Top</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;